import mutations from './mutations';
import actions from './actions';
import purchaseData from './purchaseData';
import getters from './getters';

export const initialState = {
  packagesList: [],
  ordersList: [],
  subscriptionsList: [],
  purchasesList: [],
};

export default {
  state: {
    ...initialState,
  },
  mutations,
  actions: {...actions, ...purchaseData},
  getters,
};
